/**
 * Created by spepa on 24.12.2024
 */

const MSPwaPayments = function () {
    Payments.call(this, connector.MSPWA);
    this.service = undefined;
};

MSPwaPayments.prototype = Object.create(RestPayments.prototype);
MSPwaPayments.prototype.constructor = MSPwaPayments;

MSPwaPayments.isAppropriate = function () {
    return connector.platform.oneOf(connector.MSPWA);
};

MSPwaPayments.prototype._connect = function (callback) {
    if (!window.getDigitalGoodsService) {
        callback(connector.STATUS_DISCONNECTED);
        return;
    }

    window.getDigitalGoodsService("https://store.microsoft.com/billing").then((service) => {
        this.service = service;

        this.service.getDetails(["shiny_sword", "gem", "monthly_subscription"]).then((itemDetails) => {
            console.log("MSPRODUCTS", itemDetails);
            Object.values(this.products).forEach(function (ourProduct) {
                const msProduct = itemDetails.find((item) => item.itemId === ourProduct.productId);
                if (msProduct) {
                    ourProduct.textPrice = `${msProduct.price.value} ${msProduct.price.currency}`;
                    ourProduct.currency = msProduct.price.currency;
                    this.currency = ourProduct.currency;
                    console.log(`MSPwaPayments product ${ourProduct.itemId} ${ourProduct.productId} ${ourProduct.textPrice}`);
                }
            });
            callback(connector.STATUS_CONNECTED);
        }).catch((e) => {
            console.error("Failed fetching products details", e);
            callback(connector.STATUS_CONNECTED);
        });
    }).catch(() => {
        callback(connector.STATUS_DISCONNECTED);
    });
};